/* eslint-disable react-native/no-inline-styles */
import React, { FC, useMemo } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { makeStyles } from './SystemStatus.styles';
import { useTheme } from '../../hooks/useTheme';
import Icon from '../Icon/Icon';

export enum STATES {
  POSITIVE = 'positive',
  NEUTRAL = 'neutral',
  NEGATIVE = 'negative',
}

export interface SystemStatusAction {
  testID: string;
  label: string;
  type: STATES;
  action?: () => void;
}

const SystemStatusRow: FC<SystemStatusAction> = ({
  testID,
  label,
  type: status,
  action,
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => makeStyles(colors), [colors]);

  const STATUS_MAPPING = {
    positive: {
      icon: {
        size: 20,
        name: 'UilAngleRight',
        color: colors.disclosure,
      },
      text: colors.text,
    },
    negative: {
      icon: {
        size: 18,
        name: 'UilAngleRight',
        color: colors.disclosure,
      },
      text: colors.states.negative,
    },
    neutral: {
      icon: {
        size: 20,
        name: 'UilAngleRight',
        color: colors.disclosure,
      },
      text: colors.blue,
    },
  };
  const { icon, text } = STATUS_MAPPING[status] || STATUS_MAPPING.neutral;

  return (
    <TouchableOpacity
      testID={testID}
      style={styles.option}
      onPressOut={() => {
        action && action();
      }}
    >
      <Text style={[styles.text, { color: text }]}>{`${label}`}</Text>
      <View style={styles.icon}>
        <Icon size={icon.size} name={icon.name} color={icon.color} />
      </View>
    </TouchableOpacity>
  );
};

export default SystemStatusRow;
